import React from "react";
import "./CancellationPolicy.css";

const CancellationPolicy = () => {
  return (
    <div className="container">
      <h1>Cancellation Policy</h1>
      
      <p>
        At <span className="bold">Albums and Art</span>, we understand that circumstances can change, and you may need to cancel your order. To ensure a smooth process for both our customers and our production team, we have established the following cancellation policy:
      </p>
      
      <h2>1. 24-Hour Cancellation Window</h2>
      <p>
        Orders can only be cancelled within 24 hours of the purchase. This timeframe allows us to manage our resources effectively and begin the editing, design, and manufacturing processes without significant interruption.
      </p>
      
      <h2>2. Nature of Custom Orders</h2>
      <p>
        As our items are custom-made, we must adhere strictly to the 24-hour cancellation policy. Once this period has expired, we begin work on your order, and cancellations cannot be processed.
      </p>
      
      <h2>3. How to Cancel Your Order</h2>
      <ul>
        <li><strong>Step 1:</strong> If you wish to cancel your order, please contact our customer service team as soon as possible. You can use the "Request Callback" form on the home page or email us at <span className="bold">info@albumsandart.com</span>.</li>
        <li><strong>Step 2:</strong> Provide your order number and the details of your request. This information will help us locate your order quickly and assist you with the cancellation process.</li>
        <li><strong>Step 3:</strong> Our team will confirm your cancellation within 24 hours of receiving your request, provided it falls within the allowed cancellation window.</li>
      </ul>
      
      <h2>4. Refund Process</h2>
      <p>
        If your cancellation is processed within the designated timeframe, a full refund will be issued to the payment method used at the time of purchase. Please allow <span className="bold">7-10 business days</span>  or more for the refund to reflect in your account.
      </p>
      
      <p>
        We appreciate your understanding of our cancellation policy, which helps us maintain efficiency and quality in our services. If you have any questions or concerns about your order, please don’t hesitate to reach out. We are here to assist you.
      </p>
    </div>
  );
};

export default CancellationPolicy;
